import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { isLoggedInAtom, userReceivedAction } from '@root/entities/auth/atoms'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import {
  assignGoogleRequestAction,
  unassignGoogleRequestAction,
} from './google-requests'
import { redirectToGoogleAction } from './reatom-google-redirect'

import type { OAuthCode } from '@root/entities/auth'

export const redirectToGoogleAssignAction = action((ctx) => {
  redirectToGoogleAction(ctx, 'assign')
}, 'redirectToGoogleAssignAction')

export const reatomUnassignGoogle = () => {
  return reatomRequest({
    execAction: unassignGoogleRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: 'reatomUnassignGoogle',
    onResult: (ctx, result) => {
      if (Result.isFailure(result)) {
        showSnackbarAction(ctx, {
          text: i18next.t('common.something_went_wrong_try_again'),
          intent: 'error',
        })
        return
      }

      showSnackbarAction(ctx, {
        text: i18next.t('settings.google.unassign-success'),
        intent: 'success',
      })
      userReceivedAction(ctx, result.success)
    },
  })
}

export const assignGoogleAction = action(async (ctx, code: OAuthCode) => {
  const isLoggedIn = ctx.get(isLoggedInAtom)
  if (!isLoggedIn) {
    return
  }

  const result = await ctx.schedule(() =>
    assignGoogleRequestAction(ctx, { googleAuthCode: code }),
  )
  if (Result.isSuccess(result)) {
    showSnackbarAction(ctx, {
      text: i18next.t('settings.google.success'),
      intent: 'success',
    })
    userReceivedAction(ctx, result.success)
    return
  }

  showSnackbarAction(ctx, {
    text: i18next.t('settings.google.connect-error'),
    description: i18next.t('common.something_went_wrong_try_again'),
    intent: 'error',
  })
}, 'assignGoogleAction')
